/**
 * Stores
 */

import { useTicketPermissionsStore } from '@/stores/ticketPermissions';

/**
 * Clears client state that must not survive a logout or identity change.
 */
function resetSessionStores(): void {
  useTicketPermissionsStore().reset();
}

export { resetSessionStores };
